import React from "react";
import { ThemeContext } from "../../ContextProvider/ThemeContext";
import WindowSize from "../../Utils/WindowSize";
import styles from "./About.module.css";

const About = () => {
  const { newTheme } = React.useContext(ThemeContext);
  const [width] = WindowSize();
  const img =
    width < 650
      ? "https://lh3.googleusercontent.com/pw/AP1GczN93D68Qz0iv6-W1sxt1cfda-I-cCuResVjcGfo-hbye-bvEGTnefYdd1aBjJP7E9W08pdb4zRJ5jSoLo7ko8B4wBIvs9crzgYfjcNgD-aYBmBL0mCyjCN6VFB29pQIKaUfTfnpRRqwOPiypngvuFsXOw=w780-h890-s-no-gm" // my Picture
      : "https://cdn2.careeraddict.com/uploads/article/58447/illustration-woman-desk-computers.jpg";
  return (
    <div
      className={styles.container}
      style={{ boxShadow: `3px 3px 5px ${newTheme.line}` }}
    >
      <div className={styles.first}>
        <img
          src={
            "https://cdn2.careeraddict.com/uploads/article/58447/illustration-woman-desk-computers.jpg"
          }
          alt=""
        />
      </div>
      <div className={styles.second}>
        <h1 style={{ color: `${newTheme.title}` }} className={styles.heading}>
          About Me
        </h1>
        <div className={styles.borderBottom} />
        <p style={{ color: `${newTheme.para}` }} className={styles.aboutMe}>
          Hello! Everyone I am Kirankumar J Meshram 
          <br />
          Experienced Full Stack Web Developer with expertise in the MERN
          stack—proficient in creating dynamic, scalable, and user-centric web
          applications using MongoDB, Express.js, React.js, and Node.js. With a
          strong certification background, I excel in utilizing modern web
          technologies to deliver seamless and robust solutions. Additionally, I
          have foundational knowledge in blockchain and Salesforce, enabling me
          to explore innovative integrations and future-forward development.
          <span style={{ color: `#00a0a0` }}>
            {" "}
            Adaptive to new technology and environment.
          </span>
        </p>
      </div>
    </div>
  );
};

export default About;
